import React, { useState } from 'react'
import auth from './firebase';


//npm install -g firebase-tools
//npm i firebase

import firebase from 'firebase/app'

import 'firebase/auth'







function Login() {
  const [email, setEmail] = useState('')
  const [passwd, setPasswd] = useState('')



  //console.log(process.env)
  // Initialize the FirebaseUI Widget using Firebase.
  const emailLogin = () => {

  }

  const emailRegister = () => {

  }


  const googleLogin = () => {
    var provider = new firebase.auth.GoogleAuthProvider();

    firebase.auth().signInWithPopup(provider).then(function (result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;
      // ...
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      alert(errorMessage)
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });

  }

  return (
    <div className="container text-center">
      <h1>Login Page</h1>
      <div className="w-50 p-3 m-auto mt-100 mybg">
        <form className="px-4 py-3">
          <div className="form-group">
            <label htmlFor="exampleDropdownFormEmail1">Email address</label>
            <input type="email" className="form-control" id="exampleDropdownFormEmail1" placeholder="email@example.com" onChange={e => setEmail(e.target.value)} />
          </div>
          <div className="form-group">
            <label htmlFor="exampleDropdownFormPassword1">Password</label>
            <input type="password" className="form-control" id="exampleDropdownFormPassword1" placeholder="Password" onChange={e => setPasswd(e.target.value)} />
          </div>

          <button type="submit" className="btn btn-warning">Sign in</button><br />or<br />
          <button className="btn btn-block btn-primary" onClick={googleLogin} >Sign In With Google</button>
        </form>

        <div className="dropdown-divider"></div>
        <button type="submit" className="btn btn-warning">Sign up</button><br />

        <a className="dropdown-item" href="#">Forgot password?</a>
      </div>
    </div>




  )
}

export default Login
